/*
 * Segmento de atuação da empresa (enum CompanyCategory do backend). Hoje só barbearia; a
 * categoria existe para a plataforma atender outros segmentos no futuro (ex.: PET).
 *
 * O rótulo vem do i18n pela chave com o valor em minúsculo ("barbershop"), a mesma que a
 * coluna "trans" da grade usa. Valor novo aqui pede a chave de tradução correspondente.
 */
const CompanyCategory = {
    BARBERSHOP: 'BARBERSHOP',
};

// Categoria de toda empresa nova, como no backend (CompanyCategory.DEFAULT).
export const DEFAULT_COMPANY_CATEGORY = CompanyCategory.BARBERSHOP;

export default CompanyCategory;
